"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isWebPSupported = void 0;
const web_env_1 = require("@snapchat/web-env");
const MIN_FIREFOX_VERSION = 65;
const MIN_EDGE_VERSION = 18;
const MIN_IOS_VERSION = 14;
// Big Sur MacOs 11, still returns it's browser agent as 10.5.6
// ref: https://bugs.webkit.org/show_bug.cgi?id=216593
// so we're unable to detect webp support for Safari on MacOs at the moment
const MIN_MACOS_VERSION = 11;
// Cache this boolean in order to avoid making all the work in isWebPSupported every time it runs:
let canUseWebP = undefined;
// Detect Full WebP support
// https://www.npmjs.com/package/supports-webp-sync
function isWebPSupported() {
    if (typeof canUseWebP !== "undefined") {
        return canUseWebP;
    }
    // don't run this check on the server
    if ((0, web_env_1.isRunningOnServer)()) {
        canUseWebP = false;
        return canUseWebP;
    }
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const elem = (0, web_env_1.getDocument)().createElement("canvas");
    if (elem.toDataURL("image/webp").startsWith("data:image/webp")) {
        canUseWebP = true;
        return canUseWebP;
    }
    // check browsers
    // eslint-disable-next-line @typescript-eslint/prefer-regexp-exec
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    let matches = (0, web_env_1.getNavigator)().userAgent.match(/(Edg|Firefox)\/(\d+)\./);
    if (matches) {
        return (
        // @ts-ignore
        (matches[1] === "Firefox" && matches[2] >= MIN_FIREFOX_VERSION) ||
            // @ts-ignore
            (matches[1] === "Edg" && matches[2] >= MIN_EDGE_VERSION));
    }
    // eslint-disable-next-line @typescript-eslint/prefer-regexp-exec
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    matches = (0, web_env_1.getNavigator)().userAgent.match(/OS X\s?(?<os>\d+)?.+ Version\/(?<v>\d+\.\d+)/);
    if (matches) {
        return (
        // @ts-ignore
        matches.groups.v >= MIN_IOS_VERSION &&
            // @ts-ignore
            (matches.groups.os || 99) >= MIN_MACOS_VERSION);
    }
    canUseWebP = false;
    return canUseWebP;
}
exports.isWebPSupported = isWebPSupported;
//# sourceMappingURL=webp.js.map